import gql from 'graphql-tag'

const GET_GROUP_EVENT_BY_SLUG = gql`
  query GetGroupEventBySlug($slug: String) {
    groupEvents(slug: $slug) {
      __typename
      id
      createdAt
      startDateTime
      endDateTime
      registrationCloseDateTime
      lessonCount
      paymentRecurrenceSchedule
      totalPriceInCents
      numberOfPayments
      externalRegistrationUrl
      coach {
        id
        name
        profileUrl
        pgaCoachEligible
        coachProfile {
          profilePhoto
          displayName
          firstName
          lastName
          slug
          title
          memberType
          certificationLevel
        }
      }
      academy {
          id
          name
          slug
        }
      tags
      timezone
      isCanceled
      unlisted
      title
      priceInCents
      featuredImageUrl
      slug
      coachFacility {
        id
        name
        street
        city
        state
        zipCode
        latitude
        longitude
      }
      description
      registrationFull
      registrationClosed
      registrationCount
      maxAttendance
      sessions {
        id
        startDateTime
        endDateTime
      }
      requiresAccessCode
      hasWaitlist
    }
  }
`

export default GET_GROUP_EVENT_BY_SLUG
